import { useMemo } from "react";

import { getBrowserDetect } from "utils/document";

export const useBrowserDetect = () => {
  const userAgent =
    typeof navigator === "undefined" ? "SSR" : navigator.userAgent;

  return useMemo(() => getBrowserDetect(userAgent), [userAgent]);
};
